function getUser({ input, output, services }) {
  services.Http
    .post('/api/user/get', { _id: input._id })
    .then(output.success)
    .catch(output.error)
}

getUser.async = true
getUser.outputs = ['success', 'error']

export default getUser



// WEBPACK FOOTER //
// ./src/modules/user/actions/getUser.js